import { render, staticRenderFns } from "./ChatHistorico.vue?vue&type=template&id=35cd9d78&scoped=true"
import script from "./ChatHistorico.vue?vue&type=script&lang=js"
export * from "./ChatHistorico.vue?vue&type=script&lang=js"
import style0 from "./ChatHistorico.vue?vue&type=style&index=0&id=35cd9d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd9d78",
  null
  
)

export default component.exports